
import { css } from 'lit';
export default css`
pc-chip-card .chip{
    width:-moz-fit-content;
    width:fit-content;
  }
  pc-chip-card [slot='eyebrow']{
    display:flex;
    column-gap:var(--spacing-2);
    align-items:baseline;
    margin-bottom:var(--spacing-6);
  }
  pc-chip-card + pc-chip-card[stacked]{
    padding-top:var(--spacing-8);
  }
  @media (min-width: 992px){
  pc-chip-card + pc-chip-card[stacked]{
      padding-top:var(--spacing-16)
  }
    }
`;